import React from 'react';

const TopNav = ({ version }) => {
    return (
        <nav
            className="glass-panel flex-between"
            style={{
                padding: '1rem 2rem',
                marginTop: '1rem',
                marginBottom: '1rem',
                backgroundColor: 'var(--primary-main)',
                color: 'white',
                border: 'none',
                borderRadius: '0'
            }}
        >
            <div className="flex-center" style={{ gap: '1rem' }}>
                <div
                    style={{
                        width: 32,
                        height: 32,
                        background: 'var(--secondary-main)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                        <path d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
                        <circle cx="12" cy="12" r="5" />
                    </svg>
                </div>
                <h1 style={{ fontSize: '1.5rem', fontWeight: 600, letterSpacing: '-0.02em', color: 'white' }}>
                    Weather Trends Dashboard
                </h1>
            </div>

            <div
                className="flex-center"
                style={{
                    padding: '0.25rem 0.75rem',
                    borderRadius: '20px',
                    background: 'rgba(255,255,255,0.15)',
                    border: '1px solid rgba(255,255,255,0.2)'
                }}
            >
                <span style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.9)', fontWeight: 500 }}>
                    Model Version : <span style={{ color: 'white', fontWeight: 700 }}>{version}</span>
                </span>
            </div>
        </nav>
    );
};

export default TopNav;
